// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"O6-z"};